import { AfterViewInit, Directive, Host, Input, OnDestroy, OnInit } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { Subscription } from 'rxjs';
import { DataTableNewComponent } from '../data-table-new.component';

export interface MultiselectStatus {
  active: boolean;
  disabled?: boolean;
}

@Directive({ selector: '[vfsDatatableMultiselect]', exportAs: 'vfsDatatableMultiselect' })
export class DatatableMultiselectDirective implements OnInit, AfterViewInit, OnDestroy {
  @Input() multiselectStatus: MultiselectStatus;
  @Input() multiselectActiveColumn: string;
  @Input() multiselectUnactiveColumn: string;
  @Input() multiselectEnabled = true;

  multiselectActiveBeforeColumn: string;
  multiselectUnactiveBeforeColumn: string;

  multiselectChangeSubscription: Subscription;

  constructor(@Host() private parent: DataTableNewComponent<any>) {
    this.parent.withMultiselect = true;
  }

  ngOnInit() {
    this.parent.withMultiselect = this.multiselectEnabled;
    this.parent.multiselectStatus = this.multiselectStatus;
  }

  ngAfterViewInit() {
    if (!this.multiselectStatus) {
      throw Error('Multiselect status field is mandatory!');
    }

    if (
      this.multiselectActiveColumn &&
      this.multiselectUnactiveColumn &&
      this.multiselectActiveColumn === this.multiselectUnactiveColumn
    ) {
      throw Error('Multiselect active and unactive columns are the same column!');
    }

    this.multiselectActiveBeforeColumn = this.identifyBeforeColumn(this.multiselectActiveColumn);
    this.multiselectUnactiveBeforeColumn = this.identifyBeforeColumn(this.multiselectUnactiveColumn);

    // Hide column to show when multiselect is active
    this.removeColumn(this.multiselectActiveColumn);

    if (this.parent.multiselect) {
      this.multiselectChangeSubscription = this.parent.multiselect.changeEvt.subscribe((change: MatCheckboxChange) => {
        this.parent.multiselectStatus.active = change.checked;

        if (change.checked) {
          this.addColumn(this.multiselectActiveColumn, this.multiselectActiveBeforeColumn);
          this.removeColumn(this.multiselectUnactiveColumn);
        } else {
          this.addColumn(this.multiselectUnactiveColumn, this.multiselectUnactiveBeforeColumn);
          this.removeColumn(this.multiselectActiveColumn);
          this.parent.selection.clear();
        }
      });
    }
  }

  ngOnDestroy() {
    if (this.multiselectChangeSubscription) {
      this.multiselectChangeSubscription.unsubscribe();
    }
  }

  private identifyBeforeColumn(column: string): string {
    if (!column) {
      return null;
    }

    // ... let's check it exists for real, so that you are not cheating ;)
    const columnIdx: number = this.parent.columns.indexOf(column);
    if (columnIdx <= 0) {
      return null;
    }

    return this.parent.columns[columnIdx - 1];
  }

  private addColumn(column: string, beforeColumn: string) {
    if (!column) {
      return;
    }

    if (!beforeColumn) {
      this.parent.columns.splice(0, 0, column);
    } else {
      const beforeColumnIdx: number = this.parent.columns.indexOf(beforeColumn);
      this.parent.columns.splice(beforeColumnIdx + 1, 0, column);
    }
  }

  private removeColumn(column: string) {
    if (!column) {
      return;
    }

    const columnIdx: number = this.parent.columns.indexOf(column);
    if (columnIdx >= 0) {
      this.parent.columns.splice(columnIdx, 1);
    }
  }
}
